import React, { useState, useContext } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const CriteriaCheckboxes = ({ criteria, register, errors }) => {
  const context = useContext(EligibilityContext);
  const options = criteria.options.split(";");
  const [selectedValues, setSelectedValues] = useState([]);

  return (
    <fieldset className="u-mb4">
      <legend>
        {criteria.criteria}

        {errors[criteria.name] && errors[criteria.name].type === "required" && (
          <span data-validate="error">Please make a selection.</span>
        )}
      </legend>

      {options.map((option, index) => (
        <div className="u-mb1" key={index}>
          <input
            id={`${criteria.name}-${index}`}
            type="checkbox"
            value={option}
            onChange={(e) => {
              if (selectedValues.indexOf(option) >= 0) {
                setSelectedValues((prev) => prev.filter((x) => x === option));
              } else setSelectedValues((prev) => [...prev, option]);
            }}
          />
          <label htmlFor={`${criteria.name}-${index}`}>{option}</label>
        </div>
      ))}

      <input
        type="hidden"
        name={criteria.name}
        ref={register({ required: true })}
        readOnly={true}
        onChange={null} // disable controlled/uncontrolled warning
        value={
          selectedValues.length > 0
            ? JSON.stringify({
                criteria: criteria.criteria,
                fundId: context.state.diseaseFund.fundId,
                answerType: criteria.answerType,
                response: selectedValues.join(";"),
                id: criteria.id,
                criteriaMetaDataName: criteria.criteriaMetaDataName,
              })
            : "" // if no response, set value to empty string for validation
        }
      />
    </fieldset>
  );
};

export default CriteriaCheckboxes;
